export default __webpack_public_path__ + "static/media/Logo2.74cb31a2.png";